import axios from "axios"
import { getAllCamposPersonalizadosAdapter } from "./CampoPersonalizado.adapter"
import { GetAllCamposPersonalizadosDtoIPagedEnumerableProps } from "./Schemas/GetAllCamposPersonalizadosDtoIPagedEnumerable"

interface GetCampoPersonalizadoPrestamoQueryParams {
  Keyword?: string
  SortingCriteria?: string
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}
export async function getCampoPersonalizadoPrestamo(
  queryParams?: GetCampoPersonalizadoPrestamoQueryParams
): Promise<GetAllCamposPersonalizadosDtoIPagedEnumerableProps> {
  const { data }: { data: GetAllCamposPersonalizadosDtoIPagedEnumerableProps } =
    await axios.get("/CampoPersonalizadoPrestamo/claves", {
      params: queryParams,
    })
  return {
    currentPage: data.currentPage,
    items: data.items?.map((campo) => getAllCamposPersonalizadosAdapter(campo)),
    totalCount: data.totalCount,
  }
}
